import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faFilter, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { faTimes, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import DashboardChatWidget from "./chatWidget";
import Filters from "./Filters";
import Config from "./Config";
import logoNoText from '../assets/img/datum_logo_notext.svg';

import '../styles/SideBar.scss';


const Sidebar = (props:any) => {
    const localId = `sidebar-show-${props.dashboardId}`;
    const [showing, setShowing] = useState(false /*localStorage.getItem(localId) === null ? false : localStorage.getItem(localId)  === 'false'*/);
    const [eventKey, setEventKey] = useState('chat');
    const [currentZoom, setCurrentZoom] = useState(100);

    React.useEffect(() => {
        localStorage.setItem(localId, showing.toString());
      }, [showing]);
    
    const toggle = () => {
        setShowing(!showing);
    }

    const onClick = (key:string) => {
        setEventKey(key);
        toggle();
    }

    const handleSelect = (key:any) => {
        setEventKey(key);
    }

    const callSetCurrentZoom = (e: any) => {
        console.log(e)
        console.log("-",e.target.value,"-")
        if (e.target.value === ''){
            console.log("-BLANK-")
            setCurrentZoom( 99.9 );
        }
        const val = parseInt(e.target.value);
        if ((val <= 100) && (val >= 0)){
           setCurrentZoom( val );
           updateZoom( val );
        }
    }

    const zoomInOut = (p:string) => {
        console.log(p)
        switch (p) {
            case 'in':
                if (currentZoom <= 90){
                    setCurrentZoom(currentZoom + 10 );
                    updateZoom(currentZoom + 10 );
                }
                break;
            case 'out':
                if (currentZoom >= 10){
                    setCurrentZoom(currentZoom - 10 );
                    updateZoom(currentZoom - 10);
                }
                break;            
            default:
                console.log("Zoom not updated");
        }
        //document.body.style.zoom = currentZoom.toString() + "%";
    }
    const updateZoom = (_currentZoom:number) => {
        console.log(_currentZoom)
        document.body.style.zoom = _currentZoom.toString() + "%";
    }
    return (
        <div className={`sidebar right ${showing ? "" : "collapsed"}`} style={{}}>      
            {
                !showing 
                &&
                <div className="sidebar-toggle-content">
                    <div 
                        className="sidebar-toggle right"
                        onClick={() => onClick('chat')}
                        title="Chat Bot"
                    >
                        { showing ? '': <FontAwesomeIcon icon={faComment} /> }
                    </div>

                    <div 
                        className="sidebar-toggle right"
                        onClick={() => onClick('filter')}
                        title="Filters" 
                    >
                        { showing ? '': <FontAwesomeIcon icon={faFilter} /> }
                    </div>

                    <div 
                        className="sidebar-toggle right"
                        onClick={() => onClick('config')}
                        title="Config"
                    >
                        { showing ? '': <FontAwesomeIcon icon={faSlidersH} /> }
                    </div>                    
                    <div 
                        className="ml-2 right sidebar-toggle"
                        title="Datum"
                        style={{ width: "65%", position: "absolute", bottom:"5px" }}
                    >
                        { showing ? '': <a href="/" style={{ width: "100%" }}>
                                            <img
                                                src={logoNoText}
                                                width="100%"
                                                className="d-inline-block align-middle logo-padding"
                                                alt={"Datum Geospatial"}
                                            />
                                            {``} {/* <-- Text associated with image may go here, e.g., Powered by Syncarto™ */}
                                        </a> 
                        }
                    </div>
                </div>
            }
            
            <div className="sidebar-content">
                <div 
                    className="sidebar-close right"
                    onClick={() => toggle()}
                >
                    { showing ? <FontAwesomeIcon icon={faTimes} /> : '' }
                </div>
                <Tab.Container defaultActiveKey={eventKey} activeKey={eventKey} onSelect={handleSelect}>
                    <div className="sidebar-tabs nav nav-tabs">
                        <Nav>
                            <Nav.Item>
                                <Nav.Link eventKey="chat">CHAT BOT</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="filter">FILTERS</Nav.Link>
                            </Nav.Item>                            
                            <Nav.Item>
                                <Nav.Link eventKey="config">CONFIG</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <Tab.Content style={{ flex: 1, minHeight: 0, paddingTop: "10px" }}>
                        <Tab.Pane eventKey="chat" style={{height: "100%"}}>
                            <DashboardChatWidget
                                session={props.session}
                                dashboardData={props.dashboardData}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="filter" style={{height: "100%"}}>
                            <Filters
                                sessionId={props.session.id}>
                            </Filters>
                        </Tab.Pane>                        
                        <Tab.Pane eventKey="config" style={{height: "100%"}}>
                            <Config
                                sessionId={props.session.id}
                                onSaveDashboard={props.onSaveDashboard}
                                onAddWidget={props.onAddWidget}
                                isPublic={props.isPublic}
                                showDashboardOptions={true}
                            >
                            </Config>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>           
            </div>
            {/*<div style={ showing ? { display: "flex", position: "relative", width: "155px", top: "-35px", left: "-144px" } : { display: "flex", position: "relative", width: "125px", top: "-35px", left: "-186px" }}>
                <div 
                    style={{ marginRight: "10px" }}
                    className="sidebar-toggle right"
                    onClick={() => zoomInOut("in")}
                    title="Zoom In"
                >
                <FontAwesomeIcon icon={faPlus} />
                </div>    
                    <input
                        style={{height:"30px", width:"70px"}}
                        type='number'
                        min='1'
                        max='100'
                        value={(currentZoom !== 99.9) ? currentZoom : ''}
                        onChange={callSetCurrentZoom}
                        pattern="^-?[0-9]\d*\.?\d*$"
                    /><span style={{top:"4px", left:"-30px", color:"#000", width:"0", position:"relative"}}>%</span>
                <div 
                    style={{ marginLeft: "10px" }}
                    className="sidebar-toggle right"
                    onClick={() => zoomInOut("out")}
                    title="Zoom Out"
                >
                <FontAwesomeIcon icon={faMinus} />
                </div> 
            </div>*/}
        </div>
    );
}

export default Sidebar;